import { DisclosurePhysicianResource } from "../types/EdhResourceSupport";

export const mapPhysicianResourceToEdhPrimaryPhysicianResource = (
  caseId: string,
  payload: any,
) => {
  return [
    {
      lastVisitDateExplicitlyUnknown: true,
      physicianExpected: true,
      physicianIdentifier: {
        caseId: caseId,
        uuid: payload.uuid,
      },
    },
  ];
};

export const updateDislosurePhysicianList = (
  disclosurePhysicians: DisclosurePhysicianResource[],
  disclosurePhysician: DisclosurePhysicianResource,
) => {
  let updatedDisclosurePhysicians = disclosurePhysicians;

  // Add newly created disclosure physician to embedded disclosure physicians.
  if (disclosurePhysicians) {
    const existingDisclosurePhysicianIndex = disclosurePhysicians.findIndex(
      (physician) =>
        physician.disclosureIdentifier.aliasName ===
        disclosurePhysician.disclosureIdentifier.aliasName,
    );

    if (existingDisclosurePhysicianIndex > -1) {
      // Replace existing physician with new on update.
      updatedDisclosurePhysicians[existingDisclosurePhysicianIndex] =
        disclosurePhysician;
    } else {
      // Add new on create.
      updatedDisclosurePhysicians.push(disclosurePhysician);
    }
  } else {
    updatedDisclosurePhysicians = [disclosurePhysician];
  }

  return updatedDisclosurePhysicians;
};
